// Bits of a data source column's `flags` bitmask (DataSourceColumnFlags on the server).
// A column can carry several flags at once, so always test individual bits rather than comparing raw values.
export const COLUMN_FLAG_BITS = {
  NULLABLE: 1,
  UNIQUE: 2,
  PRIMARY_KEY: 4,
  AUTOGENERATED: 8,
  MATCHING: 16,
  AS_OF_DATE: 32,
  TRACK_UNIQUE_VALUES: 64,
  SENSITIVE: 128,
  ACES_REFERENCE: 256,
};

export const hasColumnFlag = (flags, bit) => ((flags ?? 0) & bit) > 0;

export const isMatchingColumn = (column) =>
  hasColumnFlag(column?.flags, COLUMN_FLAG_BITS.MATCHING);

export const isAsOfDateColumn = (column) =>
  hasColumnFlag(column?.flags, COLUMN_FLAG_BITS.AS_OF_DATE);
